import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-gradient-to-br from-orange-500 to-orange-600 w-10 h-10 rounded-lg flex items-center justify-center font-bold text-white text-xl">
                F
              </div>
              <div>
                <div className="text-white font-bold text-lg leading-none">Firebyte</div>
                <div className="text-orange-500 text-xs leading-none">Websites</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              AI-powered websites and automations built for auto shops across the USA
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>AI-Powered Websites</li>
              <li>24/7 Call Assistants</li>
              <li>Online Booking Systems</li>
              <li>Customer Follow-Ups</li>
              <li>Lead Capture & Nurture</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4">Get In Touch</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:+15551234567" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  <Phone className="h-4 w-4" />
                  <span>(555) 123-4567</span>
                </a>
              </li>
              <li>
                <a href="mailto:hello@firebytewebsites.com" className="flex items-center gap-2 text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  <Mail className="h-4 w-4" />
                  <span>hello@firebytewebsites.com</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin className="h-4 w-4 flex-shrink-0 mt-0.5" />
                <span>Serving Automotive Shops<br />Across the USA</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm text-center md:text-left">
            © {currentYear} Firebyte Websites. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-orange-500 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
